var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{staticClass:"caption ma-0 pa-0",attrs:{"items":_vm.object,"divider":"/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }